import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptions } from '@kurtosys/types/query/IQueryOptions.js';
import { IQueryOptionsGlobal } from '@kurtosys/types/query/options/IQueryOptionsGlobal.js';

import { helpers } from '../../common/index.js';
import { queryHelper } from '../queryUtils/index.js';

import { BaseQuery } from './base/BaseQuery.js';

export class GlobalQuery extends BaseQuery<IQueryOptionsGlobal> {
	constructor(
		public dependencies: IQueryClassDependency & ITransformClassDependency,
		public queryOptions: IQueryOptions,
		public translationHelper?: helpers.TranslationHelper,
	) {
		super(dependencies, queryOptions, translationHelper);
	}

	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsGlobal {
		const { key, keyQuery, options = {} } = this.queryOptions;
		return {
			key,
			keyQuery,
			...(options.global || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions, callStackLevel = 1): T {
		const { key } = this.options;
		const context = queryHelper.getContext(executionOptions, this.queryOptions);
		if (key && context) {
			const { globalQueries } = context;
			if (globalQueries && Array.isArray(globalQueries)) {
				const globalQuery = globalQueries.find((globalQuery): boolean => globalQuery.queryId === key);
				if (globalQuery) {
					const query = new this.dependencies.queryClass(
						globalQuery,
						this.translationHelper,
						callStackLevel + 1,
					);
					return query.execute(executionOptions);
				}
			}
		}
		return;
	}
}
